import axios from '../requester';
import { API } from 'common/constants/api-urls';

export const getIntegrationTokens = async (
  integrationId,
  {
    limit = 20,
    offset = 0,
    order_by = 'created_at',
    order_dir = 'desc',
    state
  } = {}
) =>
  await axios.post(
    `${API.SENSOR_AUTHORIZATIONS_PATH}/${integrationId}/tokens/search`,
    {
      limit,
      offset,
      order_by,
      order_dir,
      ...(state && { state })
    }
  );

export const createIntegrationToken = async ({
  token,
  integrationId,
  username
}) => {
  return await axios.post(
    `${API.SENSOR_AUTHORIZATIONS_PATH}/${integrationId}/tokens`,
    {
      token: { token },
      profile: { username }
    }
  );
};

export const deleteIntegrationToken = async ({ integrationId, tokenId }) => {
  return await axios.delete(
    `${API.SENSOR_AUTHORIZATIONS_PATH}/${integrationId}/tokens/${tokenId}?soft_delete=1`
  );
};
